// Seeded mock profiles for the Discover feed.
// Uses the same shape as own-profile from onboarding/data.js.
export const MOCK_PROFILES = [
  {
    id: "kai-nakamura",
    fullName: "Kai Nakamura",
    username: "kai.builds",
    age: 26,
    gender: "Male",
    profileIcon: "Rocket",
    bio: "Shipping a B2B SaaS solo. Nights are for deep work. Looking for someone who ships weekly, no excuses.",
    city: "Tokyo",
    country: "Japan",
    timezone: "Asia/Tokyo",
    goalTags: ["Startup", "Programming"],
    goalDescription: "Reach $10k MRR on my B2B SaaS before June. Ship one meaningful feature every week.",
    level: "Intermediate",
    target: "$10k MRR",
    targetDate: "2026-06-30",
    importance: 10,
    isPrimary: true,
    chronotype: "night",
    dailyHours: 8,
    focusLength: "90 mins",
    productivityMethods: ["Deep Work", "Time Blocking"],
    challenges: ["Perfectionism", "Burnout"],
    missGoalsStory: "I over-engineer. I ship late. I need someone to force me to release.",
    idealDay: [
      { id: 1, start: "12:00", end: "14:00", label: "Deep work — features" },
      { id: 2, start: "20:00", end: "23:00", label: "Deep work — bugs & sales" },
    ],
    nonNegotiableBlocks: [2],
    workingDays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    availableStart: "19:00",
    availableEnd: "23:59",
    meetingFrequency: "Every 2 Days",
    sessionDuration: "1 hr",
    communication: ["Voice", "Discord", "Screen Share"],
    comfortableTimezones: ["UTC+8", "UTC+9", "UTC+5:30"],
    accountabilityStyle: ["Direct criticism", "Daily check-ins", "Silent co-working"],
    disappearAction: "roast",
    motivationType: "letdown",
    strictness: 9,
    honesty: 10,
    shareProgress: true,
    sharedGoals: false,
    lookingFor: "Same Industry",
    partnerLevel: "Same",
    ageRange: [22, 34],
    partnerGender: "No Preference",
    languagesSpoken: ["English", "Japanese"],
    languagesPreferred: ["English"],
    minCommitment: 6,
    maxTimezoneDiff: 8,
    dealBreakers: ["Frequently cancels", "Inactive", "Too casual"],
    partnerDescription: "Someone building something real. No students who quit at exam time. No hobbyists.",
    introExtro: 3,
    plannerSpont: 7,
    compCoop: 4,
    seriousFun: 3,
    optRealist: 6,
    logicEmo: 3,
    interests: ["Coding", "AI", "Finance", "Chess", "Podcasts"],
    quote: "Ship, then think.",
    funFact: "I've deleted my Twitter account 4 times.",
    commitmentDuration: "6 months",
    activePartnerships: "1",
  },
  {
    id: "aditi-sharma",
    fullName: "Aditi Sharma",
    username: "aditi.gate",
    age: 22,
    gender: "Female",
    profileIcon: "BookOpen",
    bio: "GATE CSE 2027 aspirant. 6 hours of pure study every morning, no phone. Need someone equally serious.",
    city: "Bengaluru",
    country: "India",
    timezone: "Asia/Kolkata",
    goalTags: ["Exam Prep", "Academic"],
    goalDescription: "Crack GATE CSE 2027 with AIR under 500. Then IISc.",
    level: "Intermediate",
    target: "AIR < 500",
    targetDate: "2027-02-15",
    importance: 10,
    isPrimary: true,
    chronotype: "morning",
    dailyHours: 6,
    focusLength: "90 mins",
    productivityMethods: ["Pomodoro", "Deep Work", "Task Lists"],
    challenges: ["Phone Addiction", "Inconsistency"],
    missGoalsStory: "Instagram. It's Instagram every single time.",
    idealDay: [
      { id: 1, start: "05:30", end: "06:00", label: "Wake, water, walk" },
      { id: 2, start: "06:00", end: "09:00", label: "Deep study — DSA" },
      { id: 3, start: "10:00", end: "12:00", label: "Deep study — OS/CN" },
      { id: 4, start: "16:00", end: "18:00", label: "Revision + mock" },
    ],
    nonNegotiableBlocks: [2, 3],
    workingDays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    availableStart: "05:30",
    availableEnd: "20:00",
    meetingFrequency: "Daily",
    sessionDuration: "2 hrs",
    communication: ["Silent co-working", "Voice", "WhatsApp"],
    comfortableTimezones: ["UTC+5:30", "UTC+3", "UTC+8"],
    accountabilityStyle: ["Daily check-ins", "Morning reminders", "Silent co-working", "Strict deadlines"],
    disappearAction: "call",
    motivationType: "streaks",
    strictness: 8,
    honesty: 9,
    shareProgress: true,
    sharedGoals: true,
    lookingFor: "Same Goal",
    partnerLevel: "Same",
    ageRange: [20, 28],
    partnerGender: "No Preference",
    languagesSpoken: ["English", "Hindi", "Tamil"],
    languagesPreferred: ["English", "Hindi"],
    minCommitment: 5,
    maxTimezoneDiff: 3,
    dealBreakers: ["Misses check-ins", "Inactive", "Too casual"],
    partnerDescription: "Another GATE aspirant or someone in equally intense prep. Morning person. Not chatty during study hours.",
    introExtro: 4,
    plannerSpont: 9,
    compCoop: 7,
    seriousFun: 3,
    optRealist: 7,
    logicEmo: 6,
    interests: ["Books", "Chess", "AI", "Coding"],
    quote: "The best time to plant a tree was 20 years ago. The second best time is now.",
    funFact: "I have a 380-day Duolingo streak just for stress relief.",
    commitmentDuration: "1 year",
    activePartnerships: "2",
  },
  {
    id: "elena-rossi",
    fullName: "Elena Rossi",
    username: "elena.writes",
    age: 31,
    gender: "Female",
    profileIcon: "Feather",
    bio: "Writing my first novel (60k words in). Also cutting 10kg. Two goals, one disciplined life. Would love a co-writer or lifter to keep me honest.",
    city: "Rome",
    country: "Italy",
    timezone: "Europe/Rome",
    goalTags: ["Writing", "Fitness"],
    goalDescription: "Finish first draft of my novel (90k words) by April. Reach 65kg lean.",
    level: "Advanced",
    target: "90k words + 65kg",
    targetDate: "2026-04-30",
    importance: 9,
    isPrimary: true,
    chronotype: "flexible",
    dailyHours: 4,
    focusLength: "60 mins",
    productivityMethods: ["Time Blocking", "Deep Work"],
    challenges: ["Perfectionism", "Motivation"],
    missGoalsStory: "I edit while I write. Then I hate everything and stop.",
    idealDay: [
      { id: 1, start: "07:00", end: "08:00", label: "Gym — lift" },
      { id: 2, start: "09:00", end: "12:00", label: "Writing — no edits" },
      { id: 3, start: "17:00", end: "18:00", label: "Walk + audiobook" },
    ],
    nonNegotiableBlocks: [2],
    workingDays: ["Mon", "Tue", "Wed", "Thu", "Fri"],
    availableStart: "07:00",
    availableEnd: "21:00",
    meetingFrequency: "Every 2 Days",
    sessionDuration: "1 hr",
    communication: ["Voice", "Video", "Text"],
    comfortableTimezones: ["UTC+1", "UTC+0", "UTC-5"],
    accountabilityStyle: ["Gentle encouragement", "Celebrating wins", "Scheduled calls"],
    disappearAction: "remind",
    motivationType: "positive",
    strictness: 5,
    honesty: 8,
    shareProgress: true,
    sharedGoals: false,
    lookingFor: "Just Someone Consistent",
    partnerLevel: "No Preference",
    ageRange: [25, 45],
    partnerGender: "No Preference",
    languagesSpoken: ["Italian", "English", "French"],
    languagesPreferred: ["English"],
    minCommitment: 3,
    maxTimezoneDiff: 6,
    dealBreakers: ["Negative attitude", "Frequently cancels"],
    partnerDescription: "A warm human who's chasing a real thing. Writer, lifter, artist — I don't care about domain, just consistency.",
    introExtro: 6,
    plannerSpont: 5,
    compCoop: 8,
    seriousFun: 6,
    optRealist: 8,
    logicEmo: 6,
    interests: ["Books", "Cooking", "Cinema", "Music", "Travel"],
    quote: "Nulla dies sine linea. — Not a day without a line.",
    funFact: "I once ran a marathon on 3 hours' sleep. Never again.",
    commitmentDuration: "3 months",
    activePartnerships: "1",
  },
];

export const getMockProfile = (id) => MOCK_PROFILES.find((p) => p.id === id);

// Canned partner replies for chat auto-responder.
export const CANNED_REPLIES = [
  "Just wrapped a focus block. You?",
  "That's the spirit. Let's lock in a session tomorrow?",
  "Sending my check-in in 5.",
  "Skipped Instagram today. Tiny win.",
  "Behind schedule but not off it. Recovering.",
  "Let's do a silent 90-min at your morning slot.",
  "You still on for tomorrow 7am?",
  "Honest question — are you actually doing the work or just planning it?",
  "Ok. Deep work now. Talk later.",
  "Reviewed your task list. Ambitious. I like it.",
];
